module.exports = __webpack_public_path__ + "static/img/5.e47ef3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/5.png
// module id = JfcM
// module chunks = 0